import { ClientChannelString, TrialType, TrueFalse } from '../../../../enum/src/lib/enum.common';
import { Injectable } from '@angular/core';
import { CommonService } from '@fitness-force/api';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { ClassAppointmentBehaviour, ClassStatusNumeric, ClientBookingStatusNumeric, ClientCheckedInStatus, ClientCheckinEventType, ClientSubscriptionFreezeStatus, EmailTransactionLogStatus, InvoiceStatusEnum, PaymentDerivedStatus, PaymentStatusEnum, PayModeLevel1, PlanCategory, SmsTransactionStatus, SubscriptionStatus, TransactionType, WhatsAppMessageTransactionLogStatus } from '@fitness-force/enum';
import { DatePicker, Dropdown, HiddenField, MultiSelect, RelativeDate, REPORTSTOREINTERFACE, Textbox, TimePeriodDropdown } from '@fitness-force/models';
import { InputSwitch } from '@fitness-force/models';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportDataService {
  timePeriod = this.commonService.GetTimePeriods();
  centers!: Observable<any> | any;
  tenantId!: Observable<any> | any;

  public tenantObs = new Subject<number>();

  commonFields = [
    new HiddenField({
      value: '',
      key: 'from_date',
      label: '',
      required: false,
      order: 0,
      type: 'hidden',
    }),
    new HiddenField({
      value: '',
      key: 'to_date',
      label: '',
      required: false,
      order: 0,
      type: 'hidden',
    }),
  ];

  defaultOptions: Array<any> = [{ key: "All", value: 'null' }];
  defaultOptionsForClientServiceCategoryReport: Array<any> = [{ key: "Any", value: 'null' }];
  paymemt_status_values: Array<any> = [];
  paymemt_mode_values: Array<any> = [];


  constructor(private commonService: CommonService) {
    Object.keys(PaymentStatusEnum).filter((x) => Number.isNaN(Number(x))).map((key) => {
      this.paymemt_status_values.push(PaymentStatusEnum[key as keyof typeof PaymentStatusEnum])
    });

    Object.keys(PayModeLevel1).filter((x) => Number.isNaN(Number(x))).map((key) => {
      this.paymemt_mode_values.push(PayModeLevel1[key as keyof typeof PayModeLevel1])
    });
  }


  getDefaultPayload(relativeDate: RelativeDate, zone: string, fields: { key: string, value: any }[], fromDate?: Date, toDate?: Date) {
    let payload: any = {};
    if (relativeDate == RelativeDate.CustomDateRange) {
      payload.from_date = fromDate!.toISOString();
      payload.to_date = toDate!.toISOString();
    }
    else {
      payload.from_date = this.commonService.GetRelativeFromDate(new Date(), relativeDate, 0)?.from_date?.toISOString();
      payload.to_date = this.commonService.GetRelativeFromDate(new Date(), relativeDate, 0)?.to_date?.toISOString();
    }
    payload.time_zone = zone;
    payload.page_no = 1;
    payload.page_size = 9999999;
    if (fields && fields.length > 0) {
      fields.forEach((value: { key: string, value: any }) => {
        payload[value.key] = value.value;
      })
    }
    return payload;
  }

  getPayload(zone: string, fields: { key: string, value: any }[]) {
    let payload: any = {};
    payload.from_date = "";
    payload.to_date = "";
    payload.page_no = 1;
    payload.page_size = 9999999;
    payload.time_zone = zone;
    if (fields && fields.length > 0) {
      fields.forEach((value: { key: string, value: any }) => {
        payload[value.key] = value.value;
      })
    }
    return payload;
  }

  getCustomDateRange(date: Date, days: number) {
    return new Date(new Date(date.setDate(date.getDate() + days)).setHours(0,0,0,0));
  }

  /**
   *
   * @param tenantId
   * @param applicationState: application state is ref to application state(ngrx),
   * @returns
   */

  GetReportStoreData(tenantId: number, applicationState: any, languageCode:string="en") {
    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const INITIAL_REPORT_STATE: REPORTSTOREINTERFACE[] = [
      {
        report_key: 'SubscriptionSignUpReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: null },{ key: "plan_subscription_category", value: null },  { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.Today, localTimeZone, [{ key: "plan_id", value: null }, { key: "plan_subscription_category", value: null },{ key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          new Dropdown({
            value: null,
            key: 'plan_subscription_category',
            label: 'Subscription Type',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(Object.keys(PlanCategory).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PlanCategory[key as keyof typeof PlanCategory],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'created_by',
            label: 'Created By',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientListReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "full_name", value: null }, { key: "home_club_id", value: this.tenantId }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "full_name", value: null }, { key: "home_club_id", value: this.tenantId }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'PaymentReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "str_payment_mode_level_1", value: null }, { key: "str_payment_status", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.Today, localTimeZone, [{ key: "str_payment_mode_level_1", value: null }, { key: "str_payment_status", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new MultiSelect({
            value: this.paymemt_mode_values,
            key: 'str_payment_mode_level_1',
            label: 'Payment Mode',
            required: true,
            order: 2,
            options: Object.keys(PayModeLevel1).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PayModeLevel1[key as keyof typeof PayModeLevel1],
              };
            }),
          }),
          new MultiSelect({
            value: this.paymemt_status_values,
            key: 'str_payment_status',
            label: 'Payment Status',
            required: true,
            order: 3,
            options: Object.keys(PaymentStatusEnum).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PaymentStatusEnum[key as keyof typeof PaymentStatusEnum],
              };
            }),
          })
          , new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SubscriptionDetailReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "subscription_status", value: '' }, { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "subscription_status", value: null }, { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'subscription_status',
            label: 'Subscription Status',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key: key.replace(/([A-Z])/g, ' $1').trim(),
                value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'created_by',
            label: 'Created By',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'InProgressSubscriptionSignups',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.LastSevenDays, localTimeZone, [{ key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.LastSevenDays].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ChargesFees',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "category_id", value: '' },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Charge Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.charge_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'FailedSubscriptionSignups',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.Today, localTimeZone, [{ key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          // new Dropdown({
          //   value: 'null',
          //   key: 'clt_subs_status',
          //   label: 'Subscription Status',
          //   required: true,
          //   order: 1,
          //   options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
          //     return {
          //       key: key.replace(/([A-Z])/g, ' $1').trim(),
          //       value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
          //     };
          //   })),
          // })
        ].concat(this.commonFields),
      },
      {
        report_key: 'CompletedTasksByStaff',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "staff_id", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'staff_id',
            label: 'Staff',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'SubscriptionExpired',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.LastSevenDays, localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.LastSevenDays].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SubscriptionNotRenewing',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null }, { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.CustomDateRange, localTimeZone, [{ key: "staff_id", value: null }, { key: "created_by", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }], this.getCustomDateRange(new Date(), 1), this.getCustomDateRange( new Date(), 31))),
        default_relative_Date: RelativeDate[RelativeDate.CustomDateRange].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          // new Dropdown({
          //   value: 'null',
          //   key: 'clt_subs_status',
          //   label: 'Subscription Status',
          //   required: true,
          //   order: 1,
          //   options: this.defaultOptions.concat(Object.keys(SubscriptionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
          //     return {
          //       key: key.replace(/([A-Z])/g, ' $1').trim(),
          //       value: SubscriptionStatus[key as keyof typeof SubscriptionStatus],
          //     };
          //   })),
          // }),
          new Dropdown({
            value: 'null',
            key: 'created_by',
            label: 'Created By',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'WonBackClient',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.LastThirtyDays, localTimeZone, [{ key: "staff_id", value: null }])),
        default_relative_Date:RelativeDate[RelativeDate.LastThirtyDays].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ChurnClient',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),

        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.LastMonth, localTimeZone, [{ key: "staff_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date:
          RelativeDate[RelativeDate.LastMonth].toString(),
          isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'AppointmentByCoach',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "coach_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "coach_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Staff',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'AppointmentByCategory',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Appointment Type Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.appointmentTypes),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'CancelledAppointmentByCategory',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientCheckIns',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "event_type", value: null }, { key: "access_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.Today, localTimeZone, [{ key: "event_type", value: null }, { key: "access_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: '',
            key: 'event_type',
            label: 'CheckedIn Events',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(Object.keys(ClientCheckinEventType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientCheckinEventType[key as keyof typeof ClientCheckinEventType],
              };
            })),
          }),
          new Dropdown({
            value: '',
            key: 'access_status',
            label: 'Access status',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(Object.keys(ClientCheckedInStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientCheckedInStatus[key as keyof typeof ClientCheckedInStatus],
              };
            })),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'NewJoinerClient',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "include_rejoin", value: true }, { key: "include_drop_in", value: true }, { key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "include_rejoin", value: true }, { key: "include_drop_in", value: true }, { key: "plan_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          new InputSwitch({
            value: true,
            key: 'include_rejoin',
            label: 'Include Rejoiners',
            required: true,
            order: 3,
          }),
          new InputSwitch({
            value: true,
            key: 'include_drop_in',
            label: 'Include Drop-in',
            required: true,
            order: 4,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'InvoiceSummary',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "sales_rep", value: null }, { key: "str_inv_status", value: null }, { key: "created_by", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "sales_rep", value: null }, { key: "str_inv_status", value: null }, { key: "created_by", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: { can_be_client_rep: any }) => s.can_be_client_rep).map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new MultiSelect({
            value: '',
            key: 'str_inv_status',
            label: 'Invoice Status',
            required: false,
            order: 3,
            options: Object.keys(InvoiceStatusEnum).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: InvoiceStatusEnum[key as keyof typeof InvoiceStatusEnum],
              };
            }),
          }),


          new Dropdown({
            value: 'null',
            key: 'created_by',
            label: 'Created By',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            }))
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClassAttendance',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "class_type_id", value: null }, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_booking_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "class_type_id", value: null }, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_booking_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_id',
            label: 'Class Type',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.classTypes)
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Coach',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: {role: string; can_take_class: any }) => s.can_take_class || s.role =='Admin').map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_behaviour',
            label: 'Class behaviour',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(Object.keys(ClassAppointmentBehaviour).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClassAppointmentBehaviour[key as keyof typeof ClassAppointmentBehaviour],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'class_booking_status',
            label: 'Status',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(Object.keys(ClientBookingStatusNumeric).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientBookingStatusNumeric[key as keyof typeof ClientBookingStatusNumeric],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClassSummary',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{key:"class_type_name_company_level",value:null},{ key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{key:"class_type_name_company_level",value:null}, { key: "coach_id", value: null }, { key: "class_type_behaviour", value: null }, { key: "class_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_name_company_level',
            label: 'Class Types',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.classTypes)
          }),
          new Dropdown({
            value: 'null',
            key: 'coach_id',
            label: 'Coach',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: {role: string; can_take_class: any }) => s.can_take_class || s.role =='Admin').map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'class_type_behaviour',
            label: 'Class behaviour',
            required: false,
            order: 4,
            options:this.defaultOptions.concat(Object.keys(ClassAppointmentBehaviour).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClassAppointmentBehaviour[key as keyof typeof ClassAppointmentBehaviour],
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'class_status',
            label: 'Status',
            required: false,
            order: 5,
            options: this.defaultOptions.concat(Object.keys(ClassStatusNumeric).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClassStatusNumeric[key as keyof typeof ClassStatusNumeric],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SalesByServiceCategory',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: '' }, { key: "sales_rep", value: null },{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "plan_id", value: null }, { key: "sales_rep", value: null },{ key: "category_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() } ])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }), new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'InvoiceDetail',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ARAgingSummaryByClient',
        claims: [],
        payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "balance_greater_than": 0,"as_on_date":new Date(),"number_of_aging_intervals":5,"aging_interval_period_grouping_in_days":15}),
        default_payload: JSON.stringify({ "time_zone":localTimeZone,"page_no": 1, page_size: 100, "clt_client_rep_id": null, "balance_greater_than": 0,"as_on_date":new Date(),"number_of_aging_intervals":5,"aging_interval_period_grouping_in_days":15}),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'balance_greater_than',
            label: 'Balance greater',
            order: 3,
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'number_of_aging_intervals',
            label: 'No Of Intervals',
            order: 4,
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'aging_interval_period_grouping_in_days',
            label: 'Interval period in Days',
            order: 5,
          }),
          new DatePicker({
            value: null,
            required: false,
            key: 'as_on_date',
            label: 'As On Date',
            order: 3,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ARAgingDetailReport',
        claims: [],
        payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "sales_rep": null, "balance_greater_than": 0,"as_on_date":new Date(),"number_of_aging_intervals":5,"aging_interval_period_grouping_in_days":15,"localized_value": false,"language_code": languageCode}),
        default_payload: JSON.stringify({ "time_zone":localTimeZone,"page_no": 1, page_size: 100, "sales_rep": null, "balance_greater_than": 0,"as_on_date":new Date(),"number_of_aging_intervals":5,"aging_interval_period_grouping_in_days":15,"localized_value": false,"language_code": languageCode}),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'balance_greater_than',
            label: 'Balance greater',
            order: 3,
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'number_of_aging_intervals',
            label: 'No Of Intervals',
            order: 4,
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'aging_interval_period_grouping_in_days',
            label: 'Interval period in Days',
            order: 5,
          }),
          new DatePicker({
            value: null,
            required: false,
            key: 'as_on_date',
            label: 'As On Date',
            order: 3,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'DiscountReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "plan_id", value: '' }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "plan_id", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'plan_id',
            label: 'Plans',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState.plans),
          }),
          new Dropdown({
            value: 'null',
            key: 'sales_rep',
            label: 'Sales Rep',
            required: true,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'TaskDone',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "category_id", value: null },{ key: "staff_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "category_id", value: null },{ key: "staff_id", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode }])),
        default_relative_Date: RelativeDate[RelativeDate.LastSevenDays].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Task Category',
            required: true,
            order: 3,
            options: this.defaultOptions.concat(applicationState.task_category),
          }),
          new Dropdown({
            value: 'null',
            key: 'staff_id',
            label: 'Staff',
            required: true,
            order: 3,
            options: this.defaultOptions.concat(applicationState?.staff?.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientCreditBalance',
        claims: [],
        payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "balance_greater_than": 0,"str_tenant_ids":tenantId.toString() }),
        default_payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "balance_greater_than": 0 ,"str_tenant_ids":tenantId.toString()}),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: false,
            order: 1,
            options: this.defaultOptions.concat(applicationState?.staff.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Textbox({
            value: 0,
            required: false,
            key: 'balance_greater_than',
            label: 'Balance greater',
            order: 2,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'MembershipRenewedReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "clt_client_rep_id", value: null }, {key: "category_id", value: null }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisQuarter, localTimeZone, [{ key: "clt_client_rep_id", value: null }, {key: "category_id", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisQuarter].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: false,
            order: 1,
            options: this.defaultOptions.concat(applicationState?.staff.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'MembershipExpiredReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "clt_client_rep_id", value: null }, {key: "category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "clt_client_rep_id", value: null }, {key: "category_id", value: null },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: false,
            order: 1,
            options: this.defaultOptions.concat(applicationState?.staff.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState.service_category),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'CreditBalanceTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "staff_id", value: null },{ key: "credit_balance_transaction_type", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisQuarter, localTimeZone, [{ key: "staff_id", value: null },{ key: "credit_balance_transaction_type", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisQuarter].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'staff_id',
            label: 'Staff',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState?.staff.map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
          new Dropdown({
            value: 'null',
            key: 'credit_balance_transaction_type',
            label: 'Transaction Type',
            required: false,
            order: 3,
            options:this.defaultOptions.concat(Object.keys(TransactionType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: TransactionType[key as keyof typeof TransactionType],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientsByServiceCategory',
        claims: [],

        payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "client_channel": null,"as_on_date":new Date(),"client_source":null,"client_status":null ,"category_id":null,"localized_value": false,"language_code": languageCode}),
        default_payload: JSON.stringify({"time_zone":localTimeZone, "page_no": 1, page_size: 100, "clt_client_rep_id": null, "client_channel": null,"as_on_date":new Date(),"client_source":null,"client_status":null ,"category_id":null,"localized_value": false,"language_code": languageCode}),
        default_relative_Date: RelativeDate[RelativeDate.Today].toString(),
        isCompanyLevel:false,
        mandatory_fields: [         
          new Dropdown({
            value: 'null',
            key: 'clt_client_rep_id',
            label: 'Client Rep',
            required: true,
            order: 1,
            options: this.defaultOptions.concat(applicationState?.staff?.filter((s: { can_be_client_rep: any }) => s.can_be_client_rep).map((staff: any) => {
              return {
                key: staff.name,
                value: staff.id,
              };
            },
            ))
          }),
           new Dropdown({
            value: 'null',
            key: 'client_channel',
            label: 'Channel',
            required: false,
            order: 2,
            options:this.defaultOptions.concat(Object.keys(ClientChannelString).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientChannelString[key as keyof typeof ClientChannelString].toString(),
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'client_source',
            label: 'Source',
            required: false,
            order: 3,
            options: this.defaultOptions.concat(CONSTANTS_DATA.CHANNEL_SOURCES.reduce((acc:any[], curr) => {
              curr.source.forEach(item => {
                acc.push({ key : item, value : item });  // Push key-value pair as an object
              });
              return acc;
            }, []))
          }),
          new Dropdown({
            value: 'null',
            key: 'client_status',
            label: 'Status',
            required: false,
            order: 4,
            options: this.defaultOptions.concat(CONSTANTS_DATA.CLIENT_STATUS.filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key : key.key,
                value: key.value,
              };
            })),
          }),
          new Dropdown({
            value: 'null',
            key: 'category_id',
            label: 'Service Category',
            required: true,
            order: 5,
            options: this.defaultOptionsForClientServiceCategoryReport.concat(applicationState.service_category),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SalesReturnDetailReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'EmailTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }, { key: "email_transaction_status", value: null } ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "email_transaction_status", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'email_transaction_status',
            label: 'Email Transaction Status',
            required: false,
            order: 3,
            options:this.defaultOptions.concat(Object.keys(EmailTransactionLogStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: EmailTransactionLogStatus[key as keyof typeof EmailTransactionLogStatus],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'SMSTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }, { key: "sms_transaction_status", value: null } ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "sms_transaction_status", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'sms_transaction_status',
            label: 'Sms Transaction Status',
            required: false,
            order: 3,
            options:this.defaultOptions.concat(Object.keys(SmsTransactionStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: SmsTransactionStatus[key as keyof typeof SmsTransactionStatus],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'WhatsAppTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }, { key: "whatsapp_transaction_status", value: null } ])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone,  [{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() },{ key: "whatsapp_transaction_status", value: null }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'whatsapp_transaction_status',
            label: 'Whatsapp Transaction Status',
            required: false,
            order: 3,
            options:this.defaultOptions.concat(Object.keys(WhatsAppMessageTransactionLogStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: WhatsAppMessageTransactionLogStatus[key as keyof typeof WhatsAppMessageTransactionLogStatus],
              };
            })),
          }),
        ].concat(this.commonFields),
      },
      {
        report_key: 'PaymentTransactionReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "payment_mode_level_1_single", value: null }, { key: "payment_log_derived_status", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "payment_mode_level_1_single", value: null }, { key: "payment_log_derived_status", value: null }, { key: "sales_rep", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: 'null',
            key: 'payment_mode_level_1_single',
            label: 'Payment Mode',
            required: true,
            order: 2,
            options: Object.keys(PayModeLevel1).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PayModeLevel1[key as keyof typeof PayModeLevel1],
              };
            }),
          }),
          new Dropdown({
            value: 'null',
            key: 'payment_log_derived_status',
            label: 'Payment Derived Status',
            required: true,
            order: 3,
            options: Object.keys(PaymentDerivedStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: PaymentDerivedStatus[key as keyof typeof PaymentDerivedStatus],
              };
            }),
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'CountByMemberCategoryWise',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "service_category_name", value: '' },{key:"include_non_base_membership",value:false},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "service_category_name", value: '' },{key:"include_non_base_membership",value:false},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:true,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: '',
            key: 'service_category_name',
            label: 'Service Category Name',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(applicationState.service_category),
          }),
          new InputSwitch({
            value: true,
            key: 'include_non_base_membership',
            label: 'Include Non Base Membership',
            required: false,
            order: 3,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'ClientTrialReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "trial_type", value: 'ClassBased' },{key:"conversion",value: true},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "trial_type", value: 'ClassBased' },{key:"conversion",value: true},{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: '',
            key: 'trial_type',
            label: 'Trial Type',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(Object.keys(TrialType).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: TrialType[key as keyof typeof TrialType],
              };
            })),
          }),
          new InputSwitch({
            value: true,
            key: 'conversion',
            label: 'Conversion',
            required: false,
            order: 3,
          })
        ].concat(this.commonFields),
      },
      {
        report_key: 'FreezeReport',
        claims: [],
        payload: JSON.stringify(this.getPayload(localTimeZone, [{ key: "freeze_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_payload: JSON.stringify(this.getDefaultPayload(RelativeDate.ThisMonth, localTimeZone, [{ key: "freeze_status", value: null },{ key: "localized_value", value: false },{ key: "language_code", value: languageCode },{ key: "str_tenant_ids", value: tenantId.toString() }])),
        default_relative_Date: RelativeDate[RelativeDate.ThisMonth].toString(),
        isCompanyLevel:false,
        mandatory_fields: [
          new TimePeriodDropdown({
            value: '',
            key: 'timePeriod',
            label: 'Time Period',
            required: true,
            order: 1,
            options: this.timePeriod,
          }),
          new Dropdown({
            value: '',
            key: 'freeze_status',
            label: 'Freeze Status',
            required: false,
            order: 2,
            options: this.defaultOptions.concat(Object.keys(ClientSubscriptionFreezeStatus).filter((x) => Number.isNaN(Number(x))).map((key) => {
              return {
                key,
                value: ClientSubscriptionFreezeStatus[key as keyof typeof ClientSubscriptionFreezeStatus],
              };
            })),
          })
        ].concat(this.commonFields),
      }
    ];
    return INITIAL_REPORT_STATE;
  }
}
